import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type {
  Error,
  GetBugHuntingReportResponse
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  onError?: (error: Error) => void
  onSuccess?: (response: GetBugHuntingReportResponse) => void
  children?: (response: GetBugHuntingReportResponse) => ReactElement
  shortErrorMessage?: string
  id: string
}

const GetAiModelDefectsRequest = ({
  id,
  onError,
  onSuccess,
  children,
  shortErrorMessage
}: Props) => {
  const url = `${AI_API_SERVICE}/models/${id}/defects`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      shortErrorMessage={shortErrorMessage}
      url={url}
    />
  )
}

export default GetAiModelDefectsRequest
